import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useConnectionStore = defineStore('connection-store', () => {
    const is_connected = ref(true)

    const onConnected = () => {
        is_connected.value = true
    }

    const onDisconnected = () => {
        is_connected.value = false
    }

    const addListeners = () => {
        window.addEventListener('online', onConnected)
        window.addEventListener('offline', onDisconnected)
    }

    const removeListeners = () => {
        window.removeEventListener('online', onConnected)
        window.removeEventListener('offline', onDisconnected)
    }

    return {
        is_connected,
        onConnected,
        onDisconnected,
        addListeners,
        removeListeners,
    }
})
